export const getPressureCareOptionsException = (state) => {
    if (state.chairType === "Configura Comfort Extra Small") {
        return "Not available with Configura Comfort Extra Small.";
    }
    return null;
};
export const getLateralSupportBackrestsException = (state) => {
    if ("None" !== state.lateralSupport) {
        return "Not available with Lateral Support Wedges.";
    }
    return null;
};
export const getLateralSupportWedgesException = (state) => {
    if ("Lateral Support Backrest" === state.backrest || "Adjustable Lateral Support" === state.backrest) {
        return "Not available with Lateral Support Backrests.";
    }
    return null;
};
